<template>
  <div class="main-wrapper">
    <div class="main-scroller">
      <router-view ></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {};
  },
};
</script>

<style lang="scss"  scoped>
.main-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;

}
  .main-scroller {
    height: 100%;
    overflow: auto;
  }
</style>